<template>
  <div class="u-wrapper-panel" ref="container">
    <video-player
      :options="options"
      ref="video"
      @ready="onPlayerReady"
      @timeupdate="onTimeUpdate"
      class="u-wrapper-panel"
    />
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'

export default {
  components: {
    videoPlayer
  },
  computed: {
    options () {
      return {
        muted: false,
        language: 'en',
        sources: [{
          type: "video/mp4",
          src: this.src
        }],
        poster: this.poster,
        fluid: true,
      }
    }
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      width: 0,
      height: 0,
      currentTime: 0,
      isFullScreen: false
    }
  },
  methods: {
    onResize () {
      this.width = this.$refs.container.offsetWidth
      this.height = this.$refs.container.offsetHeight

      if (this.player) {
        // this.player.width = this.width
        // this.player.height = this.height
        // console.log('this.player.height', this.player)
      }
    },
    onPlayerReady (player) {
      this.player = player
      this.onResize()
    },
    onTimeUpdate (event) {
      this.$emit('currentTime', this.player.currentTime())
    }
  }
}
</script>

<style lang="stylus">
@import '~@/../node_modules/video.js/dist/video-js.css'

.subtitles
  position absolute
  bottom 40px
  left 20px
  right 20px
  
  &.is-fullscreen
    position fixed

.video-js .vjs-big-play-button
  top 50%
  left 50%
  transform translate(-50%, -50%)
</style>